import { RelatedSchedulesDialogItemProps } from './types';
import { RelatedSchedulesDialogSuggested } from '../suggested';
import { RelatedSchedulesDialogActions } from '../actions';
import { RelatedInternalScheduleForm } from '../forms/internal';
import { RelatedExternalScheduleForm } from '../forms/external';
import { useRescheduler } from '@contexts/rescheduler';
import { RelatedSchedulesDialogInputs } from '../inputs';
import { useState } from 'react';
import { ScheduleDialog } from '@components/rescheduler/dialog';

export const RelatedSchedulesDialogItem = ({ data }: RelatedSchedulesDialogItemProps) => {
  const { setState } = useRescheduler();
  const [open, setOpen] = useState(false);

  const { id, task, contact, extraComment } = data;
  if (!task) return;

  const { name, scheduleType, dateConfirmation, foremanSpecialty, job } = task;

  const Form =
    scheduleType === 'internal' ? RelatedInternalScheduleForm : RelatedExternalScheduleForm;

  return (
    <>
      <div className="flex flex-col gap-2.5 border-t py-4 last-of-type:border-b">
        <Form schedule={data}>
          <div className="flex flex-col gap-0.5">
            <h3 className="text-lg font-bold leading-none text-neutral-800">{name}</h3>
            <RelatedSchedulesDialogSuggested data={data} scheduleType={scheduleType} />
          </div>
          <RelatedSchedulesDialogInputs
            data={data}
            jobId={job?.id}
            scheduleType={scheduleType}
            dateConfirmation={dateConfirmation}
            specialty={[foremanSpecialty?.value || '']}
            contactId={contact?.id}
            foremanId={data.foreman?.id}
          />
          <RelatedSchedulesDialogActions
            data={data}
            onRemove={() => setState((prev) => ({ ...prev, remove: id }))}
            onEdit={() => setOpen(true)}
          />
        </Form>
      </div>
      <ScheduleDialog
        open={open}
        setOpen={setOpen}
        task={{ ...task, extraComment, schedule: data }}
        job={{
          id: task?.job?.id || '',
          projectId: task?.job?.projectId || '',
          name: task?.job?.name || '',
          address: task?.job?.address || '',
          division: task?.job?.division || { id: '', name: '' },
        }}
      />
    </>
  );
};
